import {Any} from 'json2typescript';
import {AbstractModel, JsonObject, JsonProperty} from 'projects/core/src/public-api';

@JsonObject('model.PricingSettingItemValue')
export class PricingSettingItemValue extends AbstractModel {
  @JsonProperty(Number, 'id')
  id?: number;

  @JsonProperty(String, 'name')
  name?: string;

  @JsonProperty(Any, 'value')
  value?: any;
}

@JsonObject('model.PricingSettingItem')
export class PricingSettingItem extends AbstractModel {
  @JsonProperty(String, 'field')
  field?: string

  @JsonProperty(String, 'name')
  name?: string

  @JsonProperty(PricingSettingItemValue, 'value')
  value?: PricingSettingItemValue;

  @JsonProperty(String, 'type')
  type?: string;
}

@JsonObject('model.PricingSetting')
export class PricingSetting extends AbstractModel {
  @JsonProperty([PricingSettingItem], 'items')
  items?: PricingSettingItem[]
}


